var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plot-page"
  }, [(_vm.plot) ? _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "plot-header mb-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('h1', {
    staticClass: "plot-title"
  }, [_vm._v("Plot #" + _vm._s(_vm.plot.tokenId))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-outline-dark",
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
    }
  })]), _vm._v("\n          Back to Homepage\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 mb-4"
  }, [_c('div', {
    staticClass: "plot-image-container"
  }, [_c('img', {
    staticClass: "plot-image img-fluid",
    attrs: {
      "src": 'https://millionbithomepage.com/seq/' + _vm.plot.seq + '/token.jpeg',
      "alt": "Plot Image"
    }
  })]), _vm._v(" "), (_vm.showZoomImage) ? _c('div', {
    staticClass: "plot-image-container mt-4"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.zoomImageLoaded),
      expression: "zoomImageLoaded"
    }],
    staticClass: "plot-image img-fluid",
    attrs: {
      "src": 'https://millionbithomepage.com/seq/' + _vm.plot.seq + '/zoom.gif',
      "alt": "Plot Zoom Image"
    },
    on: {
      "load": _vm.onZoomImageLoad,
      "error": _vm.onZoomImageError
    }
  }), _vm._v(" "), (_vm.zoomImageLoading) ? _c('div', {
    staticClass: "text-center py-3"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mt-2 mb-0 text-muted small"
  }, [_vm._v("Loading zoom view...")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "plot-details"
  }, [_c('div', {
    staticClass: "detail-section mb-4"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "website-link"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": _vm.plot.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                Visit Site\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "url-text mt-2"
  }, [_vm._v(_vm._s(_vm.plot.url))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-section mb-4"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_vm._v("Plot Statistics")]), _vm._v(" "), _c('div', {
    staticClass: "stats-grid"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Pixels")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.plot.pixels.toLocaleString()))])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v("(" + _vm._s(_vm.plot.x1) + ", " + _vm._s(_vm.plot.y1) + ") to (" + _vm._s(_vm.plot.x2) + ", " + _vm._s(_vm.plot.y2) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-content"
  }, [_c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Updated")]), _vm._v(" "), _c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(new Date(_vm.plot.created).toLocaleDateString()))])])])])]), _vm._v(" "), (_vm.plot.profile && _vm.hasProfileLinks) ? _c('div', {
    staticClass: "detail-section mb-4"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_vm._v("Profile Links")]), _vm._v(" "), _c('div', {
    staticClass: "profile-links"
  }, [(_vm.plot.profile.base_name) ? _c('a', {
    staticClass: "profile-link base-link",
    attrs: {
      "href": 'https://base.org/name/' + _vm.plot.profile.base_name.replace('.base.eth', ''),
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 111 111",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
      "fill": "#0052FF"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Base Name")])]) : _vm._e(), _vm._v(" "), (_vm.plot.profile.website_url && _vm.plot.profile.website_url !== _vm.plot.url) ? _c('a', {
    staticClass: "profile-link website-link",
    attrs: {
      "href": _vm.plot.profile.website_url,
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Website")])]) : _vm._e(), _vm._v(" "), (_vm.plot.profile.x_username) ? _c('a', {
    staticClass: "profile-link twitter-link",
    attrs: {
      "href": 'https://x.com/' + _vm.plot.profile.x_username,
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(_vm.plot.profile.x_username))])]) : _vm._e(), _vm._v(" "), (_vm.plot.profile.tg_url) ? _c('a', {
    staticClass: "profile-link telegram-link",
    attrs: {
      "href": _vm.plot.profile.tg_url,
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Telegram")])]) : _vm._e(), _vm._v(" "), (_vm.plot.profile.token_ca) ? _c('a', {
    staticClass: "profile-link chart-link",
    attrs: {
      "href": 'https://dexscreener.com/base/' + _vm.plot.profile.token_ca,
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Token Chart")])]) : _vm._e(), _vm._v(" "), (_vm.plot.profile.nft_ca) ? _c('a', {
    staticClass: "profile-link nft-link",
    attrs: {
      "href": 'https://magiceden.us/collections/base/' + _vm.plot.profile.nft_ca,
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("NFT Collection")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail-section"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_vm._v("View On")]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.plot.hash,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "bi bi-receipt"
  }), _vm._v(" BaseScan #" + _vm._s(_vm.plot.seq) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "href": 'https://opensea.io/item/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e/' + _vm.plot.tokenId,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "bi bi-gem"
  }), _vm._v(" OpenSea #" + _vm._s(_vm.plot.tokenId) + "\n              ")])])])])])])]) : (_vm.loading) ? _c('div', {
    staticClass: "container mt-4"
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "not-found-container"
  }, [_c('div', {
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_c('h4', {
    staticClass: "alert-heading"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }
  })]), _vm._v("\n          Plot not found\n        ")]), _vm._v(" "), _c('p', [_vm._v("The plot with ID "), _c('strong', [_vm._v(_vm._s(_vm.$route.params.id))]), _vm._v(" could not be found.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
    }
  })]), _vm._v("\n          Back to Homepage\n        ")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border spinner-border-sm text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading zoom...")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Loading plot information...")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f29c64ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plot.vue
// module id = Y5vl
// module chunks = 2